const STORAGE_KEY = 'hke_account_tour_data';

export function getTourData() {
  const data = localStorage.getItem(STORAGE_KEY);
  return data ? JSON.parse(data) : {};
}

export function setTourData(key, value) {
  const current = getTourData();
  current[key] = value;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
}

export function clearTourData() {
  localStorage.removeItem(STORAGE_KEY);
}